<template>
  <div
    :class="y > 100 ? 'sm:top-12' : 'sm:top-16'"
    class="sm:block hidden sm:pt-5 pt-0.5 sm:px-0 px-1 sm:sticky fixed bg-transparent sm:transition-all sm:duration-300 z-20 top-0 w-full"
  >
    <div class="flex items-center space-x-1 w-full">
      <div class="relative w-full" ref="historyRef">
        <div class="absolute left-0.5 top-1/2 transform -translate-y-1/2">
          <img
            src="@/assets/images/logo_small.webp"
            alt="Medium Logo"
            class="h-8"
          />
        </div>

        <input
          type="text"
          class="w-full h-13 rounded-lg border border-gray-200 focus:outline-2 focus:outline-primary-blue bg-white px-10"
          :placeholder="$t('search.search_placeholder_mobile')"
          :disabled="loading"
          v-model="search"
          @focus="handleFocus"
        />
        <div
          v-if="search.length > 2"
          class="absolute sm:right-3.5 right-2 top-1/2 transform -translate-y-1/2"
        >
          <div class="flex items-center justify-center" v-if="loading">
            <Icon name="ph:circle-notch" class="animate-spin" size="16" />
          </div>

          <button
            v-else
            @click="$emit('clear-search')"
            type="button"
            class="cursor-pointer flex items-center justify-center size-6 min-w-6 bg-gray-50 rounded-lg hover:text-white hover:bg-rose-600"
          >
            <Icon name="ph:x" size="16" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useWindowSize, useWindowScroll } from "@vueuse/core";
import { type ArtType } from "~~/types/artwork";

const emit = defineEmits(["search-by-history", "clear-search"]);

defineProps<{
  artType: ArtType;
  loading?: boolean;
}>();

const store = useArtworkStore();
const search = defineModel<string>({ default: "" });
const { width } = useWindowSize();
const { y } = useWindowScroll();

const handleFocus = () => {
  if (width.value < 640) {
    store.openSearch();
  }
};
</script>
